import StatCell from '../../../components/analysis/StatCell';
import { useEffect, useState } from 'react';

export default function TimeBreakdownTable({ data, subjectMeta }) {
  const [finalData, setFinalData] = useState(null);

  useEffect(() => {
    if (!subjectMeta || !data) return undefined;
    Object.entries(data).forEach((item) => {
      const [subject, subjectData] = item;
      subjectData.subject = subjectMeta[subject];
    });

    setFinalData(data);
  }, [data]);

  if (!finalData) return null;

  return (
    <div className="overflow-x-auto rounded-b-xl border border-t-0 border-[var(--q3-stroke-light)]">
      <table className="text-sm w-full">
        <thead className="bg-[var(--q3-surface-dim)]">
          <tr className="h-16">
            <td className="py-3 px-4 w-75 text-start align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[100px] leading-snug">Subject</div>
            </td>
            <td className="py-3 px-4 min-w-[180px] text-center align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[100px] mx-auto leading-snug">Time Spent</div>
            </td>
            <td className="py-3 px-4 min-w-[180px] text-center align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[100px] mx-auto leading-snug">Qs Attempted</div>
            </td>
            <td className="py-3 px-4 min-w-[180px] text-center align-middle">
              <div className="line-clamp-2 max-w-[100px] mx-auto leading-snug">Accuracy</div>
            </td>
          </tr>
        </thead>
        <tbody>
          {Object.values(finalData)?.map((item, index) => (
            <tr
              key={index}
              className={`border-b border-[var(--q3-stroke-light)] ${index === Object.keys(data).length - 1 && 'border-b-0'} hover:bg-[var(--q3-surface-dim)]`}
            >
              <td className="h-16 w-75 border-r border-[var(--q3-stroke-light)]">
                <div className="flex flex-row justify-start items-center px-4 gap-4">
                  <img src={item.subject.icon} alt={item.subject.subject} className="w-6 h-6" />
                  <p className="truncate text-base font-semibold text-[var(--q3-neutral-default)]">
                    {item.subject.title}
                  </p>
                </div>
              </td>
              <td className="border-r border-[var(--q3-stroke-light)] text-[var(--q3-neutral-light)] text-xs text-center font-medium">
                <span className="text-[var(--q3-neutral-default)] text-base">{item.timeSpent}</span> mins
              </td>
              <td className="border-r border-[var(--q3-stroke-light)] text-[var(--q3-neutral-light)] text-xs text-center font-medium">
                <span className="text-[var(--q3-neutral-default)] text-base">{item.attemptQuestions}</span>/
                {item.totalQuestions} Qs
              </td>
              <td className="text-center font-medium">
                <StatCell showPercentage={true} bottom={100} top={item.accuracy} color="var(--q3-accent-normal)" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
